import { parseCookies } from 'nookies';
import { notifyLandingRegister } from '@/utils/profile/landing-register/notifyLandingRegister';

export interface HandleConfirmRegistrationParams {
    phone: string;
    fullName: string;
    email: string;
    toast: (options: { className: string; title: string }) => void;
    currentStep: number;
    selectedWizard?: string;
    setCurrentStep: (step: number) => void;
    setSubmitting: (loading: boolean) => void;
    urlWithoutProtocol: string;
}

export const handleConfirmRegistration = async ({
    phone,
    toast,
    currentStep,
    setCurrentStep,
    selectedWizard,
    setSubmitting,
    urlWithoutProtocol,
}: HandleConfirmRegistrationParams) => {
    const slug = selectedWizard === 'wizard2' ? 'nokhbegan-popup' : 'wizard';
    if (!phone) {
        toast({
            className: 'bg-error/95 text-white rounded-2xl',
            title: 'لطفاً شماره موبایل خود را وارد کنید.',
        });
        return;
    }

    setSubmitting(true);

    try {
        const cookies = parseCookies();
        const token = cookies['user_auth_token'];

        if (!token) {
            toast({
                className: 'bg-error/95 text-white rounded-2xl',
                title: 'توکن کاربر پیدا نشد، لطفا دوباره وارد شوید.',
            });
            setSubmitting(false);
            return;
        }

        const response = await notifyLandingRegister(phone, token, slug, urlWithoutProtocol);

        if (response?.success) {
            toast({
                className: 'bg-success/95 text-white rounded-2xl',
                title: response.message || 'ثبت نام با موفقیت انجام شد.',
            });
            const nextStep = currentStep + 1;
            setCurrentStep(nextStep);
        } else {
            toast({
                className: 'bg-error/95 text-white rounded-2xl',
                title: response?.message || 'خطا در ثبت نام.',
            });
        }
    } catch (err) {
        console.error(err);
        toast({
            className: 'bg-error/95 text-white rounded-2xl',
            title: 'خطا در ثبت نام، لطفا دوباره تلاش کنید.',
        });
    } finally {
        setSubmitting(false);
    }
};
